export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/portrait.c382424.svg";